export default __webpack_public_path__ + "static/media/miguel-lopes-43.c235f993.jpg";